<template>
  <div class="flex min-w-0 items-center gap-2">
    <div class="flex h-8 max-w-72 items-center rounded-md border border-input bg-background px-3 text-sm shadow-sm">
      <span class="block min-w-0 truncate">
        <span v-if="showLabel" class="text-muted-foreground">
          Description:
        </span>
        <template v-for="(segment, index) in descriptionSegments" :key="`${segment.type}-${index}`">
          <a
            v-if="segment.type === 'link'"
            :href="segment.href"
            target="_blank"
            rel="noopener noreferrer"
            class="text-primary underline-offset-4 hover:underline"
          >{{ segment.text }}</a>
          <span v-else>{{ segment.text }}</span>
        </template>
      </span>
    </div>

    <Button variant="outline" size="sm" type="button" class="h-8 shrink-0" :loading="isUpdating" @click="openDescriptionModal">
      Edit
    </Button>

    <TaskTemplateDescriptionEditModal
      ref="descriptionModal"
      :task-template-id="taskTemplateId"
      :description="normalizedDescription"
      :context="context"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Button } from '../../../../../../../../resources/js/components/ui/button/index.js'
import TaskTemplateDescriptionEditModal from './TaskTemplateDescriptionEditModal.vue'
import { useTaskTemplateStore } from '../../../stores/taskTemplateStore.js'
import { buildLinkifiedTextSegments } from '../../../utils/linkifyText.js'

const props = defineProps({
  taskTemplate: {
    type: Object,
    required: true,
  },
  value: {
    type: [String, Object],
    default: null,
  },
  context: {
    type: String,
    default: 'task-template-show',
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
})

const descriptionModal = ref(null)

const taskTemplateStore = useTaskTemplateStore(props.context)
const taskTemplateId = computed(() => Number(props.taskTemplate?.id))
const isUpdating = computed(() => taskTemplateStore.isUpdatingDescription(taskTemplateId.value))
const normalizedDescription = computed(() => {
  if (typeof props.value === 'string') {
    return props.value
  }

  if (props.value && typeof props.value === 'object' && 'value' in props.value) {
    return String(props.value.value)
  }

  return props.taskTemplate?.description ?? ''
})
const descriptionLabel = computed(() => normalizedDescription.value?.trim() || 'No description')
const descriptionSegments = computed(() => buildLinkifiedTextSegments(descriptionLabel.value))

const openDescriptionModal = () => {
  descriptionModal.value?.openModal?.()
}
</script>
